
function NoPage() {
    return (
        <h1 className="mt-4 ml-4" >NON Page : Bu sayfa halen mevcut deg'il</h1>
    )
}

export default NoPage;